<template>
  <div class="invalid-feedback d-block">
    {{ errors[0] }}
  </div>
</template>

<script>
export default {
  inheritAttrs: false,

  props: {
    errors: {
      type: Array,
      default: () => [],
    },
  },
};
</script>
